'use client';

import styled from 'styled-components';

import DownloadVersion from './DownloadVersion';
import { ShowOlderVersionsProvider } from './ShowOlderVersionsProvider';
import ImageCard from '@/ui/components/Card/forGrid/ImageCard';

const DownloadProductWrap = styled.div`
  display: flex;
  flex-grow: 1;
  justify-items: center;
  gap: 30px;
  padding-bottom: 30px;
  padding-top: 30px;

  &:not(:first-child) {
    border-top: 1px #e0e0e0 solid;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: block;
    margin-left: 0;
  }
`;

const DownloadProductCard = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-flow: column;
  width: 250px;
`;

type fullWidth = {
  $fullWidth?: boolean;
};

const DownloadVersions = styled.div<fullWidth>`
  display: grid;
  gap: 30px;
  grid-template-columns: ${props => (props.$fullWidth ? 'auto' : '50% 50%')};
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: block;
  }
`;

interface DownloadProductProps {
  fullWidth: boolean;
  item: DownloadListItem;
}

export default function DownloadProduct({
  item,
  fullWidth,
}: DownloadProductProps) {
  return (
    <DownloadProductWrap id={`product-${item?.slug}`} key={item.id}>
      <DownloadProductCard>
        <ImageCard
          item={{
            id: item?.slug,
            title: item.title,
            linkUrl: `${item.link}`,
            media: {
              image: item?.image?.thumbnail || item?.image?.original || item?.image?.src,
            },
          }}
        />
      </DownloadProductCard>

      <ShowOlderVersionsProvider>
        <DownloadVersions $fullWidth={fullWidth}>
          {item?.firmware && item.firmware?.length > 0 && (
            <DownloadVersion type="firmware" items={item.firmware} productSlug={item?.slug} />
          )}

          {item?.handbook && item?.handbook?.length > 0 && (
            <DownloadVersion type="handbook" items={item.handbook} productSlug={item?.slug} />
          )}
        </DownloadVersions>
      </ShowOlderVersionsProvider>
    </DownloadProductWrap>
  );
}
